"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriorYearExportSchoolYearsResponseDto = void 0;
class PriorYearExportSchoolYearsResponseDto {
    schoolGroupId;
    schoolId;
    schoolYears;
}
exports.PriorYearExportSchoolYearsResponseDto = PriorYearExportSchoolYearsResponseDto;
